import AuthApi from './AuthApi';
import { mplService } from './Services';

// @ts-expect-error TS7006 - strict migration
function sendLogsToServer(logData) {
  if (AuthApi.isAppAuthenticated()) {
    mplService.put(`/client-logs`, logData);
  }
}

export default {
  sendLogsToServer,
};
